export default {
  currentModal(state, getters, rootState) {
    return rootState.global.modal.current;
  },
  totalCartAmount(state) {
    return state.cart.total_price;
  },
  isCartEmpty(state) {
    return state.cart.items.length === 0;
  },
  gwpType(state) {
    return state.gwp.thresholds?.length ? 'threshold' : 'collection';
  },
  gwpHandle(state) {
    return state.gwp.rewardHandle;
  },
  gwpThresholds(state) {
    return state.gwp.thresholds;
  },
  isGWPLoading(state) {
    return state.gwp.loading;
  },
  isGWPActive(state) {
    return state.gwp.active;
  },
  isGWPLayoutActive(state) {
    return state.gwp.layout;
  },
  isOnlyOneProductGWP(state) {
    return state.gwp.onlyOneProduct;
  },
  totalCartGWPAmount(state) {
    const excludedProductTypes = ['Gift Cart', 'Gift Card', 'Donation'];
    const excludedProductTotal = state.cart.items.reduce((acc, item) => {
      return (
        acc +
        (excludedProductTypes.includes(item.product_type) ||
        item.properties?._gwp
          ? item.line_price
          : 0)
      );
    }, 0);
    return state.cart.total_price - excludedProductTotal;
  },
  GWPProducts(state) {
    return state.gwp.collection;
  },
  GWPRewardProducts(state) {
    return state.gwp.rewardCollection;
  },
  GWPHandle(state) {
    return state.gwp.rewardHandle;
  },
  productsWithSubscription(state) {
    return state.cart.items
      .map((p) => {
        if (p.selling_plan_allocation?.selling_plan?.id) {
          return {
            id: p.id,
            selling_plan: p.selling_plan_allocation.selling_plan.id,
          };
        }
        return false;
      })
      .filter((id) => id !== false);
  },
  cartHasGWPProducts(state) {
    let res = false;
    if (state.gwp.collection) {
      const cartIds = state.cart.items.map(
        (i) => i.product_id || (i.id && i.properties._gwp),
      );
      if (cartIds.length > 0) {
        const productsFromCollectionInsideCart = state.gwp.collection.filter(
          (i) => {
            return cartIds.includes(parseInt(i.id));
          },
        );
        if (productsFromCollectionInsideCart.length > 0) {
          res = true;
        }
      }
    } else {
      const gwpItems = state.cart.items?.reduce((acc, rec) => {
        if (rec.properties._gwp) {
          return (acc += rec.quantity);
        }
        return acc;
      }, 0);
      if (!!gwpItems) return true;
    }
    return res;
  },
  GWPApplicableProducts(state) {
    let res = 0;
    if (state.gwp.collection && state.cart.items.length) {
      const cartIds = state.cart.items.map((i) => i.product_id || i.id);

      if (cartIds.length > 0) {
        state.cart.items.forEach((item) => {
          const matchingProduct = state.gwp.collection.find((el) => {
            const gwpVariant = el.variants.find((variant) => parseInt(variant.id) === parseInt(item.id) && variant.sourceGWPCollectionItem);
            if (gwpVariant) {
              return true;
            }

            return false;
          });

          if (matchingProduct) {
            res += item.quantity;
          }
        });
      }
    }
    return res;
  },
  gwpCollectionData(state) {
    return state.gwp.collection_data;
  },
  rewardIsOnlyOneProduct(state) {
    return state.gwp.rewardCollection.length === 1;
  },
  rewardProducts(state) {
    return state.gwp.rewardCollection;
  },
  rewardProductsAvailable(state) {
    return state.gwp.rewardCollection
      ? state.gwp.rewardCollection.filter((s) => s.available)
      : [];
  },
  rewardProductsLimit(state, getters) {
    return Math.min(
      state.gwp.rewardLimit,
      getters.rewardProductsAvailable.length,
    );
  },
  rewardUserList(state, getters) {
    return [
      ...new Set([
        ...state.gwp.userSelection,
        ...getters.gwpAlreadyAddedToCart,
        ...state.gwp.userAltSelection.map((p) => parseInt(p.id)),
      ]),
    ];
  },
  replaceProducts(state) {
    const res = state.gwp.userAltSelection;
    const altProducts = state.cart.items
      .filter((p) => p.properties._gwp_original_shadow)
      .forEach((p) => {
        let original = parseInt(p.properties._gwp_original_shadow);
        let id = parseInt(p.properties._gwp_prev_shadow);
        if (isNaN(original)) {
          original = p.product_id;
        }
        if (isNaN(id)) {
          id = p.id;
        }
        res.push({
          id,
          original,
          title: p.variant_title,
          properties: p.properties,
        });
      });
    return res;
  },
  rewardUserListNotAdded(state, getters) {
    const res = [];
    state.gwp.userSelection.forEach((id) => {
      res.push({ id: id });
    });
    state.gwp.userAltSelection.forEach((p) => {
      const data = {
        id: p.id,
        original: p.original,
      };
      if (p.properties) {
        data.properties = p.properties;
      }
      res.push(data);
    });
    return res;
  },
  rewardUserProductsLeft(state, getters) {
    return getters.rewardProductsLimit - getters.rewardUserList.length;
  },

  userSelectionReady(state, getters) {
    return getters.isGWPLayoutActive
      ? getters.rewardUserList.length >= getters.rewardProductsLimit
      : false;
  },
  gwpAlreadyAddedToCart(state) {
    return state.cart.items
      .filter((el) => el.properties._gwp)
      .map((el) => parseInt(el.id));
  },
  gwpAlreadyAltAddedToCart(state) {
    return state.cart.items.filter((el) => el.properties._gwp);
  },

  cartLineByVariantId:
    (state) =>
    ({ id, isBundle = false, properties = {}, isEditable = false }) => {
      const bundleUid = properties?._bundle_uid ?? null;
      if (!isBundle && bundleUid) isBundle = true;

      if (isEditable) {
        return state.cart.items.find((i) => `${i.id}` === `${id}`);
      }

      return state.cart.items.find(
        (i) =>
          `${i.id}` === `${id}` &&
          ((typeof i.properties?._bundle_uid !== 'undefined' &&
            isBundle &&
            bundleUid === i.properties._bundle_uid &&
            parseInt(properties._bundle_index) ===
              parseInt(i.properties._bundle_index)) ||
            (typeof i.properties?._bundle_uid === 'undefined' && !isBundle)),
      );
    },

  cartLineByProperties:
    (state) =>
    (props, items = null) => {
      items = items ?? state.cart.items;
      return items.find((i) => {
        let match = true;
        Object.keys(props).forEach((key) => {
          if (
            typeof i.properties?.[key] === 'undefined' ||
            i.properties?.[key] !== props[key]
          ) {
            match = false;
          }
        });
        return match;
      });
    },
};
